import { FC } from 'react'
import { Box, Flex, Sticky, VStack, Widget } from '@revolut-internal/ui-kit'

import { ErrorWidget } from 'components'
import { useProcessDebugDetailsContext } from 'pages/AiProcessDebugV2/hooks/useProcessDebugDetailsContext'

import { DebugDetailsHeader } from '../DebugDetailsHeader'
import { DebugDetailsLoading } from './DebugDetailsLoading'
import { NoMessageSelectedWidget } from '../NoMessageSelectedWidget'
import { DebugDetailsContent } from '../DebugDetailsContent/DebugDetailsContent'

export const DebugDetails: FC = () => {
  const {
    debugProcesses,
    isLoadingDebugProcesses,
    isDebugProcessesError,
    selectedProcessData,
    isLoadingDialogueSnapshots,
  } = useProcessDebugDetailsContext()

  if (isLoadingDialogueSnapshots || isLoadingDebugProcesses) {
    return <DebugDetailsLoading />
  }

  if (isDebugProcessesError) {
    return (
      <Flex height="100%" alignItems="center" justifyContent="center">
        <ErrorWidget title="An error occured" />
      </Flex>
    )
  }

  if (!debugProcesses.length) {
    return (
      <Flex height="100%" alignItems="center" justifyContent="center">
        <NoMessageSelectedWidget />
      </Flex>
    )
  }

  return (
    <Box height="100%" overflow="auto">
      <Sticky top={0} zIndex={10}>
        <DebugDetailsHeader />
      </Sticky>

      <Widget p="s-12">
        <VStack space="s-12" height="100%">
          <DebugDetailsContent selectedProcessData={selectedProcessData} />
        </VStack>
      </Widget>
    </Box>
  )
}
